export class PowerSupplyModel {
    public psId:number;
    public powerSupplyType:string;

 }


// WEBPACK FOOTER //
// D:/Aliva/IPCL/IPCL_SELF_CARE/src/app/models/powerSupply/power.supply.model.ts